'use client'
import { CreateManyMomentChunksInput } from '@/trpc/types'
import { vanillaApiClient } from '@/trpc/vanilla'
import { encrypt } from '@/utils'

export const fallbackSaveChunks = async ({
  textToEmbed,
  momentId,
  encryptKey,
}: {
  textToEmbed: string
  momentId: string
  encryptKey: string
}) => {
  const { values, embeddings } = await vanillaApiClient.ai.generateChunks.query(
    { content: textToEmbed },
  )
  const chunksToSave: CreateManyMomentChunksInput['chunks'] = await Promise.all(
    values.map(async (value, index) => ({
      chunkEmbeddings: embeddings[index],
      chunkEncrypted: await encrypt(value, encryptKey),
      momentId,
    })),
  )
  await vanillaApiClient.momentChunks.createMany.mutate({
    chunks: chunksToSave,
  })
}
